import { render, staticRenderFns } from "./salarySliceShow.vue?vue&type=template&id=e3edf582&scoped=true&"
import script from "./salarySliceShow.vue?vue&type=script&lang=js&"
export * from "./salarySliceShow.vue?vue&type=script&lang=js&"
import style0 from "./salarySliceShow.vue?vue&type=style&index=0&id=e3edf582&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3edf582",
  null
  
)

export default component.exports